export default __webpack_public_path__ + "static/instaIcon-2ddfb59982483a684b4925b71e359936.png";